import 'bootstrap'

function handleImageModalEvents() {
  const imageModalElement = document.getElementById('imageModal')
  const imageModalContentElement = document.getElementById('imageModalContent')

  if (imageModalElement && imageModalContentElement) {
    imageModalElement.addEventListener('show.bs.modal', event => {
      const relatedTarget = event.relatedTarget
      imageModalContentElement.innerHTML = relatedTarget.innerHTML
    })

    imageModalElement.addEventListener('hidden.bs.modal', event => {
      imageModalContentElement.innerHTML = ''      
    })
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  handleImageModalEvents()
})
